module.exports = {"TEFLORG":4,"TEFLUS":5,"IRELAND":6}


//////////////////
// WEBPACK FOOTER
// ./src/data/mcstores.json
// module id = Z8rd
// module chunks = 8